import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowLeftCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M30 16a14 14 0 1 0-28 0 14 14 0 0 0 28 0m-15.69 7.69-7-6.89A1.13 1.13 0 0 1 7 16a1.1 1.1 0 0 1 .31-.8l7-6.89a1.07 1.07 0 0 1 1.5 0 1 1 0 0 1 0 1.48L10.5 15H24a1 1 0 0 1 0 2H10.5l5.31 5.22a1 1 0 0 1 0 1.48 1.07 1.07 0 0 1-1.5-.01"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowLeftCircleFilledSVG);
ForwardRef.displayName = "IconArrowLeftCircleFilled";
export { ForwardRef as IconArrowLeftCircleFilled };
